const IndexPage = ({ data }) => (
  <main id="main-content" className="josefin-sans">
    <div className="relative">
      <Header data={data.allHeaderJson.edges[0].node} />
      <Hero data={data.allHeroJson.edges[0].node} />
    </div>
    <About data={data.allAboutJson.edges[0].node} />
    <Press data={data.allPressJson.edges[0].node} />
    <Team
      cast={data.allTeamCastJson.edges}
      creative={data.allTeamCreativeJson.edges}
    />
    <Support data={data.allSupportJson.edges[0].node} />
    <Media
      concept={data.allMediaConceptJson.edges}
      production={data.allMediaProductionJson.edges}
      video={data.allMediaVideoJson.edges}
    />
    <Subscribe data={data.allSubscribeJson.edges[0].node} />
  </main>
)

export default IndexPage

/*
 *
 * General
 *
 */

import React from 'react'

import Header from '../sections/Header'
import Hero from '../sections/Hero'
import About from '../sections/About'
import Press from '../sections/Press'
import Team from '../sections/Team'
import Support from '../sections/Support'
import Media from '../sections/Media'
import Subscribe from '../sections/Subscribe'

/*
 *
 * Queries
 *
 */

export const query = graphql`
  query IndexPageQuery {
    allHeaderJson {
      edges {
        node {
          city
          dates
          venue {
            pinkText
            whiteText
            link
          }
          socialHeading
          socials {
            site
            link
          }
          nav {
            text
            link
          }
        }
      }
    }

    allHeroJson {
      edges {
        node {
          image {
            childImageSharp {
              sizes(maxWidth: 3334) {
                ...GatsbyImageSharpSizes_withWebp
                src
              }
            }
          }
          logo {
            childImageSharp {
              sizes(maxWidth: 750) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          logoAlt
          description
        }
      }
    }

    allAboutJson {
      edges {
        node {
          heading
          synopsis
          background
          image {
            childImageSharp {
              sizes(maxWidth: 70) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
        }
      }
    }

    allPressJson {
      edges {
        node {
          image {
            childImageSharp {
              sizes(maxWidth: 946) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          reviews {
            quotation
            source
          }
        }
      }
    }

    allTeamCastJson {
      edges {
        node {
          thumbnailImage {
            childImageSharp {
              sizes(maxWidth: 200) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          modalImage {
            childImageSharp {
              sizes(maxWidth: 550) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          role
          name
          bio
          link
        }
      }
    }

    allTeamCreativeJson {
      edges {
        node {
          thumbnailImage {
            childImageSharp {
              sizes(maxWidth: 200) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          modalImage {
            childImageSharp {
              sizes(maxWidth: 550) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          alt
          role
          name
          bio
          link
        }
      }
    }

    allSupportJson {
      edges {
        node {
          image {
            childImageSharp {
              sizes(maxWidth: 2500) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          heading
          paragraph
          link {
            text
            url
          }
        }
      }
    }

    allMediaConceptJson {
      edges {
        node {
          image {
            childImageSharp {
              sizes(maxWidth: 730) {
                ...GatsbyImageSharpSizes_withWebp
                src
              }
            }
          }
          alt
        }
      }
    }

    allMediaProductionJson {
      edges {
        node {
          image {
            childImageSharp {
              sizes(maxWidth: 730) {
                ...GatsbyImageSharpSizes_withWebp
                src
              }
            }
          }
          alt
        }
      }
    }

    allMediaVideoJson {
      edges {
        node {
          url
          image {
            childImageSharp {
              sizes(maxWidth: 1280) {
                ...GatsbyImageSharpSizes_withWebp
                src
              }
            }
          }
          alt
        }
      }
    }

    allSubscribeJson {
      edges {
        node {
          image {
            childImageSharp {
              sizes(maxWidth: 2500) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
          heading
          subheading
          paragraphs
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js